import React from 'react'

const FaqButton = () => {
    return (
        <>
            <button className="infoBtn">More info</button>
        </>
    )
}

export default FaqButton
